import Mousetrap from 'mousetrap'
import { Draggable } from '@shopify/draggable'
const getSortable = () => import('sortablejs')

angular
  .module('deskfy.arts')
  .controller('CollectionListController', CollectionListController)

/* @ngInject */
function CollectionListController ($rootScope, $scope, $state, $stateParams, $translate, $timeout, $location, $q, NewAssetService, CampaignService, AssetPreviewService, ArtCollectionsService, ModalService, SegmentService, TemplateService, MemoTemplateRequestService, UdsModalService, Utils, ToastService, TagsService, FormatsService, GroupService, ConfirmationModalService, MaterialUploadService, CustomerConfigurationsService) {
  const getCreateCampaignDialogController = () => $q.when(import('../../../admin/dialogs/create-campaign/create-campaign-dialog.controller'))
  const getUploadTemplateDialogController = () => $q.when(import('../../dialogs/upload-template/upload-template-dialog.controller'))
  const getImportSvgDialogController = () => $q.when(import('../../dialogs/import/import-dialog.controller'))
  const getArtSizeDialogController = () => $q.when(import('../../dialogs/art-size/art-size-dialog.controller'))
  const getUpgradeCompanyPlanDialogController = () => import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')
  const getAttachInsideTheModuleModalController = () => $q.when(import('../../../repository/directives/attach-inside-the-module-modal/attach-inside-the-module-modal.controller'))
  const getTemplatePropertiesDialogController = () => $q.when(import('../../dialogs/template-properties/template-properties-dialog.controller'))
  const getImportTemplateNoCustomizableController = () => $q.when(import('../../dialogs/import-template-no-customizable/import-template-no-customizable.controller'))
  const getMoveTemplateCollectionController = () => $q.when(import('../../dialogs/move-template-collection/move-template-collection-dialog.controller'))

  const ANALYTICS_ADVANCED_FILTERS_KEY = 'ANALYTICS.ADVANCED_FILTERS'

  $scope.loadingMoreItems = false
  $scope.selectedTemplate = null
  $scope.iTokensCount = $rootScope.isDesktop ? 10 : 5
  $scope.location = 'materials'
  $scope.floatingBarLocation = 'materials'

  $scope.companyFeatures = {
    artsCustomization: {
      access: true
    }
  }
  $scope.sidebar = {
    selected: {},
    items: []
  }
  $scope.selectedCollections = []
  $scope.selectedTemplates = []

  $scope.templateParam = {}
  $scope.collectionParam = {}

  $scope.campaign = {
    results: [],
    state: {
      loading: true,
      count: undefined
    }
  }

  $scope.search = {
    term: '',
    templates: [],
    collections: [],
    formatId: null,
    category: null,
    count: null,
    collectionCount: null,
    templateCount: null,
    pagination: {
      collections: {
        top: 8,
        skip: 0
      },
      templates: {
        top: 8,
        skip: 0
      }
    },
    state: {
      term: '',
      searching: false,
      loading: false
    }
  }

  $scope.templateOptions = {
    edit: true,
    move: true,
    download: true,
    archive: true,
    share: true,
    settings: true,
    duplicate: true
  }

  $scope.breadcrumb = {
    history: [],
    current: null,
    loading: false,
    root: null
  }

  $scope.collectionData = {
    templates: [],
    collections: [],
    top: 10,
    templateCount: 0,
    collectionCount: 0,
    templateIndex: 0
  }
  $scope.flags = {
    showFilter: false
  }

  $scope.editMode = false

  $scope.analyticsAdvancedFilters = false

  $scope.pageTitle = ''
  $scope.headerBreadcrumbs = {}
  $scope.materialsSort = 'manual'

  const handleTemplatePagination = MemoTemplateRequestService.handlePaginationMemo()

  let sortableCollections
  let sortableTemplates

  // this defines whether the templates search will look for templates only in the current collection or in its children too
  const TEMPLATES_SEARCH_CURRENT = 'current'

  const { restartRecording, restoreScroll, stopRecording } = Utils.scrollRestoration()

  const api = {
    getCreateCampaignDialogController,
    getTemplatePropertiesDialogController,
    getUploadTemplateDialogController,
    getImportSvgDialogController,
    getArtSizeDialogController,
    getUpgradeCompanyPlanDialogController,
    getImportTemplateNoCustomizableController,
    getMoveTemplateCollectionController,
    _changeCollectionPage,
    _onCollectionSearch,
    _handleCompanyFeatures,
    _getCollectionTemplates,
    _getSubCollections,
    _changeSearchPlaceholder,
    _openTemplatePropertiesDialog,
    _searchTemplatesByProduct,
    _getCollectionById,
    _searchTemplatesByCategory,
    _activateCollectionsSortable,
    _activateTemplatesSortable,
    _onUpdate,
    _changeItemsOrder,
    _disableSortable,
    _successUpdateOrder,
    _openTemplateSettings,
    _checkEmptyValues,
    _checkIfPageExists,
    _callGetTemplates,
    _addInfiniteScroll,
    _handleNavigateThroughKeyboard,
    _handleKeyboardNavigation,
    _handleQuickPreview,
    _handleOpenQuickPreview,
    _showUpgradeCompanyPlanDialog,
    _successGetCompanyFeatures,
    _errorGetCompanyFeatures,
    _formatBreadcrumb,
    _setHeaderNavigation,
    _changeToEditMode,
    _onFilter,
    _initHeader,
    _onSearch,
    _cleanAllSelections,
    _unselectAllAndSelectNewItem,
    _addNewItemToSelectedItems,
    _unselectLastItemFromSelectedItems,
    _loadMoreCollectionsOnSearch,
    _loadMoreTemplatesOnSearch,
    _handleShiftClickOnTemplate,
    _handleShiftClickOnCollection,
    _unselectAllExceptFirstSelected,
    _unarchiveCollection,
    _moveCollection,
    _initializeDraggable,
    _handleDraggableOn,
    _handleDraggableOff,
    _handleDraggableMirror,
    _initializeHoverLogger,
    _handleMoveMultipleDragging,
    _showCollectionHasExpirationConfirmation,
    _getTemplateTarget,
    _getMaterialsSortAndOrderConfigurations
  }
  this.getApi = () => api

  activate()

  function activate (forceUpdate) {
    api._getMaterialsSortAndOrderConfigurations()
    api._handleCompanyFeatures()
      .then(() => {
        api._initHeader()
      })
    api._handleKeyboardNavigation()
    api._handleQuickPreview()

    $(document).scrollTop(0)

    if ($stateParams.pageHistory) {
      $scope.breadcrumb.history = Array.from($stateParams.pageHistory)
    }

    if ($stateParams.search) {
      $scope.search.term = $stateParams.search
    }

    if ($stateParams.root) {
      $scope.breadcrumb.root = $stateParams.root
    }

    if ($stateParams.previewId) {
      TemplateService.getTemplateById($stateParams.previewId).then((template) => {
        AssetPreviewService.openAssetPreview({
          asset: template,
          getPreviewAssets: $scope.getPreviewAssets
        })
      })
    }

    if ($stateParams.template && $rootScope.isUserSysAdminAdminDesigner()) {
      api._openTemplateSettings($stateParams.template)
    }

    const urlParams = $location.search()
    const isOnEditMode = urlParams.edit === 'true' || urlParams.edit === true
    api._setHeaderNavigation(isOnEditMode)
    if (isOnEditMode) {
      $timeout(() => {
        api._changeToEditMode(true)
      })
    }

    api._getCollectionById($stateParams.id, forceUpdate)

    if (!$scope.breadcrumb.history || ($scope.breadcrumb.history && !$scope.breadcrumb.history.length)) {
      ArtCollectionsService.getArtCollectionPath($stateParams.id).then(res => {
        $scope.breadcrumb.history = res
        $scope.pageTitle = $scope.breadcrumb.history.length ? $scope.breadcrumb.history[$scope.breadcrumb.history.length - 1].title : ''
        api._formatBreadcrumb()
      })
    }

    $rootScope.getCompanyFeaturesAndAddons()
      .then(api._successGetCompanyFeatures)
      .catch(api._errorGetCompanyFeatures)

    if ($stateParams.isArchived !== undefined) {
      const isArchivedBoolean = $stateParams.isArchived === 'true' || $stateParams.isArchived === true
      if ($scope.filters) {
        $scope.filters.isArchived = isArchivedBoolean
      } else {
        $scope.filters = { isArchived: isArchivedBoolean }
      }
    }
  }

  $scope.changeToEditMode = api._changeToEditMode

  $scope.handleFilterSearchClick = () => {
    $scope.flags.showFilter = !$scope.flags.showFilter
  }

  $scope.handleSubmitSearch = api._onSearch

  $scope.setFilters = (filters) => {
    $(document).scrollTop(0)
    $scope.flags.showFilter = false
    $scope.search.pagination.collections.skip = 0
    $scope.search.pagination.templates.skip = 0
    $scope.indexToken = 0
    $scope.filters = filters

    if (filters || $scope.search.term) {
      SegmentService.track('arts-search-collection', {
        search_text: $scope.search.term,
        is_highlight: $scope.breadcrumb.current?.highlighted,
        search_category: filters?.artTagIds,
        search_format: filters?.formatId,
        search_approval: filters?.needApproval,
        search_level: filters?.customizationLevel,
        search_group: filters?.groupId,
        search_arquived: filters?.isArchived
      })
    }
    api._onCollectionSearch($scope.search.term, filters, 0, true)
  }

  function _initializeDraggable () {
    const containers = document.querySelectorAll('.section-content-items.draggable-container')
    containers.forEach(container => {
      const draggable = new Draggable(container, {
        draggable: 'template-item, collection-item',
        handle: '.template-item-content-draggable, .collection-item-content-draggable',
        mirror: {
          appendTo: 'body',
          constrainDimensions: true
        }
      })

      draggable.on('drag:start', api._handleDraggableOn)
      draggable.on('drag:stop', api._handleDraggableOff)
      draggable.on('mirror:created', api._handleDraggableMirror)
      draggable.on('mirror:move', (event) => {
        const mirror = event.data.mirror
        mirror.style.opacity = '1'

        const allElements = mirror.querySelectorAll('*')
        allElements.forEach(element => {
          element.style.opacity = '1'
        })
      })
    })
  }

  function _initializeHoverLogger () {
    const folders = document.querySelectorAll('collection-item')
    folders.forEach(folder => {
      folder.addEventListener('mouseenter', () => {
        const folderIdWithText = folder.children[0].getAttribute('data-id')
        const folderId = folderIdWithText.replace('collection-item-', '')
        const folderName = folder.children[0].getAttribute('data-name')
        const folderNameWithoutSpaces = folderName.trim()
        $scope.currentDropTargetFolderName = folderNameWithoutSpaces
        $scope.currentDropTargetFolderId = folderId
        if ($scope.draggedItemIds && $scope.currentDropTargetFolderId) {
          folder.children[0].style.border = '1px solid #0d94ff'
          folder.children[0].style.outline = '1px solid #0d94ff'
          folder.children[0].style.zIndex = '9600'
          folder.children[0].style.position = 'relative'
        }
      })

      folder.addEventListener('mouseleave', () => {
        $scope.currentDropTargetFolderId = null
        $scope.currentDropTargetFolderName = null
        folder.children[0].style.border = null
        folder.children[0].style.outline = null
        folder.children[0].style.transform = null
        folder.children[0].style.transition = null
        folder.children[0].style.zIndex = null
        folder.children[0].style.position = null
      })
    })
  }

  function _handleDraggableOn (event) {
    api._initializeHoverLogger()
    const selectedTemplates = document.querySelectorAll('.template-item-directive.selected-template')
    const selectedCollections = document.querySelectorAll('.collection-item.selected-collection')
    const sourceElement = event.data.source

    sourceElement.setAttribute('data-is-dragging', 'true')

    if (selectedTemplates.length || selectedCollections.length) {
      selectedTemplates.forEach(card => {
        card.style.position = 'relative'
        card.children[0].style.opacity = '0.5'
      })

      selectedCollections.forEach(card => {
        card.style.position = 'relative'
        card.style.opacity = '0.5'
      })
    } else {
      sourceElement.style.position = 'relative'
      sourceElement.children[0].style.opacity = '0.5'
    }

    if (selectedTemplates.length > 1 || selectedCollections.length > 1) {
      const templatesIds = Array.from(selectedTemplates).reduce((ids, card) => {
        const cardId = card.getAttribute('data-id')
        if (!ids.includes(cardId)) {
          ids.push(cardId)
        }
        return ids
      }, [])

      const collectionsIds = Array.from(selectedCollections).reduce((ids, card) => {
        const cardIdWithText = card.getAttribute('data-id')
        const cardId = cardIdWithText.replace('collection-item-', '')
        if (!ids.includes(cardId)) {
          ids.push(cardId)
        }
        return ids
      }, [])

      $scope.draggedItemIds = {
        templates: templatesIds,
        collections: collectionsIds
      }
    } else {
      if (sourceElement.children[0].classList.contains('template-item-directive')) {
        const draggedCardId = event.data.originalSource.firstChild.dataset.id
        if (draggedCardId) {
          $scope.draggedItemIds = {
            templates: [draggedCardId],
            collections: []
          }
        }
      } else {
        const draggedCardIdWithText = event.data.originalSource.firstChild.dataset.id
        const draggedCardId = draggedCardIdWithText.replace('collection-item-', '')
        if (draggedCardId) {
          $scope.draggedItemIds = {
            templates: [],
            collections: [draggedCardId]
          }
        }
      }
    }
  }

  function _handleDraggableOff (event) {
    const selectedCards = document.querySelectorAll('.template-item-directive.selected-template')
    const selectedCollections = document.querySelectorAll('.collection-item.selected-collection')
    const draggingElements = document.querySelectorAll('[data-is-dragging="true"]')

    draggingElements.forEach(element => {
      element.removeAttribute('data-is-dragging')
    })

    if (selectedCards.length || selectedCollections.length) {
      selectedCards.forEach(card => {
        card.style.position = ''
        card.children[0].style.opacity = '1'
      })

      selectedCollections.forEach(card => {
        card.style.position = ''
        card.style.opacity = '1'
      })
    } else if (event.data.source) {
      event.data.source.style.position = ''
      event.data.source.children[0].style.opacity = '1'
    }

    const allCards = document.querySelectorAll('template-item, collection-item')
    allCards.forEach(card => {
      card.style.position = ''
      const wrapperCard = card.querySelector('.wrapper-card')
      if (wrapperCard) {
        wrapperCard.style.filter = null
        wrapperCard.style.boxShadow = null
        wrapperCard.style.transform = null
        wrapperCard.style.opacity = '1'
      }
    })

    if ($scope.draggedItemIds && $scope.currentDropTargetFolderId) {
      api._handleMoveMultipleDragging($scope.currentDropTargetFolderId)
    }
    $scope.draggedItemIds = null
    $scope.currentDropTargetFolderId = null
    event._canceled = true
  }

  function _handleDraggableMirror (event) {
    const mirror = event.data.mirror
    const count = $scope.draggedItemIds.templates.length + $scope.draggedItemIds.collections.length

    mirror.style.position = 'fixed'
    mirror.style.opacity = '1'

    mirror.setAttribute('data-is-mirror', 'true')

    const wrapperCard = mirror.querySelector('.wrapper-card')
    if (wrapperCard) {
      wrapperCard.style.opacity = '1'
      wrapperCard.style.filter = 'none'
      wrapperCard.style.boxShadow = '0 5px 15px rgba(0,0,0,0.2)'
    }

    const allElements = mirror.querySelectorAll('*')
    allElements.forEach(element => {
      element.style.opacity = '1'
      element.style.filter = 'none'
    })

    mirror.classList.add('card-mirror')

    if (count) {
      mirror.classList.add('mirror-with-counter')
      mirror.setAttribute('data-count', count)
    }

    setTimeout(() => {
      mirror.style.opacity = '1'
      if (wrapperCard) {
        wrapperCard.style.opacity = '1'
      }
      allElements.forEach(element => {
        element.style.opacity = '1'
      })
    }, 0)
  }

  async function _handleMoveMultipleDragging (targetId) {
    const promises = []
    const targetIdNumber = Number(targetId)
    const templateIds = $scope.draggedItemIds.templates.map(id => Number(id))
    const collectionIds = $scope.draggedItemIds.collections
      .map(id => Number(id))
      .filter(id => id !== targetIdNumber)
    const targetName = $scope.currentDropTargetFolderName

    const selectedOption = await ArtCollectionsService.find(targetIdNumber, {
      skipArchived: true
    })

    if ($scope.selectedTemplates.length + $scope.selectedCollections.length > 1) {
      if ($scope.selectedTemplates.length) {
        const { showDataWarning, showCollectionWarning, campaignName } = CampaignService.shouldShowCampaignWarningMultipleData($scope.selectedTemplates, selectedOption)
        if (showCollectionWarning) {
          CampaignService.showCollectionCampaignWarning()
          $scope.loadingButton = false
          return
        } else if (showDataWarning) {
          CampaignService.showDataCampaignWarning(campaignName)
          $scope.loadingButton = false
          return
        }

        promises.push(TemplateService.moveMultipleTemplates(templateIds, targetIdNumber).then(() => {
          const target = api._getTemplateTarget(selectedOption)
          templateIds.forEach(templateId => {
            SegmentService.track('arts-template-move', { art_id: templateId, target: target })
          })
        }))
      }

      if ($scope.selectedCollections.length) {
        const { showDataWarning, showCollectionWarning, campaignName } = CampaignService.shouldShowCampaignWarningMultipleData($scope.selectedCollections, selectedOption)
        if (showCollectionWarning) {
          CampaignService.showCollectionCampaignWarning()
          $scope.loadingButton = false
          return
        } else if (showDataWarning) {
          CampaignService.showDataCampaignWarning(campaignName)
          $scope.loadingButton = false
          return
        }

        promises.push(ArtCollectionsService.moveMultipleArtCollection(collectionIds, targetIdNumber).then(() => {
          collectionIds.forEach(collectionId => {
            SegmentService.track('arts-collection-move', { collection_id: collectionId })
          })
        }))
      }
    } else {
      if (templateIds.length === 1) {
        const template = await TemplateService.getTemplateById(templateIds[0])
        const { showDataWarning, showCollectionWarning, campaignName } = CampaignService.shouldShowCampaignWarning(template, selectedOption)
        if (showCollectionWarning) {
          CampaignService.showCollectionCampaignWarning()
          return
        } else if (showDataWarning) {
          CampaignService.showDataCampaignWarning(campaignName)
          return
        }

        promises.push(TemplateService.moveTemplate(template.id, targetIdNumber).then(() => {
          const target = api._getTemplateTarget(selectedOption)
          SegmentService.track('arts-template-move', { art_id: template.id, target: target })
        }))
      }

      if (collectionIds.length === 1) {
        const collection = await ArtCollectionsService.find(collectionIds[0], {
          skipArchived: true
        })
        if (collection.id === targetIdNumber || collection.parentId === targetIdNumber) {
          return
        }
        const { showDataWarning, showCollectionWarning, campaignName } = CampaignService.shouldShowCampaignWarning(collection, selectedOption)
        if (showCollectionWarning) {
          CampaignService.showCollectionCampaignWarning()
          return
        } else if (showDataWarning) {
          CampaignService.showDataCampaignWarning(campaignName)
          return
        }

        promises.push(ArtCollectionsService.moveArtCollection(collection.id, targetIdNumber).then(() => {
          SegmentService.track('arts-collection-move', { collection_id: collection.id })
        }))
      }
    }

    const moveMultiple = () => {
      if (promises.length === 0) {
        return
      }
      $q.all(promises).then(() => {
        ToastService.showSuccessToast($translate.instant('successMoveArtToast', { sectionName: targetName }))
        $scope.$emit('reload-arts-page')
      }).catch(() => {
        ToastService.showErrorToast($translate.instant('errorMoveArtToast'))
      })
    }

    ArtCollectionsService.collectionHasExpiration(targetId).then(hasExpiration => {
      if (hasExpiration) {
        api._showCollectionHasExpirationConfirmation(moveMultiple)
      } else {
        moveMultiple()
      }
    })
  }

  async function _getTemplateTarget (selectedOption) {
    let target = null
    if (selectedOption.highlighted) {
      target = 'featured collection'
    } else if (selectedOption.parentId) {
      const parent = await ArtCollectionsService.find(selectedOption.parentId, {
        skipArchived: true
      })

      if (parent.parentId) {
        target = 'sub-collection'
      } else {
        target = 'collection'
      }
    } else {
      target = 'section'
    }

    return target
  }

  function _showCollectionHasExpirationConfirmation (callback) {
    ConfirmationModalService.createModal({
      title: $translate.instant('warning'),
      htmlDescription: $translate.instant('moveArtCollectionHasExpirationConfirmation'),
      buttonConfirmText: $translate.instant('yesContinueConfirmationButton'),
      buttonCancelText: $translate.instant('cancel'),
      onConfirm: () => {
        callback()
      }
    })
  }

  const deregisterReloadArtsPage = $scope.$on('reload-arts-page', () => {
    api._cleanAllSelections()
    stopRecording()
    $scope.search.formatId = null
    $scope.search.category = null
    $scope.collectionData.templateIndex = 0
    if ($scope.search.state.searching) {
      $scope.search.count = 0
      if ($scope.search.templates.length > 1 || $scope.search.collections.length > 1) {
        $scope.search.pagination.skip = $scope.search.pagination.top * $stateParams.page || 0
        api._onCollectionSearch($scope.search.state.term, $scope.filters, $stateParams.page, true)
      } else {
        $scope.search.count = null
        api._changeCollectionPage(1, $stateParams, true)
      }
    } else {
      activate(true)
    }
  })

  $scope.$on('$destroy', () => {
    deregisterReloadArtsPage()
    document.removeEventListener('keydown', api._handleNavigateThroughKeyboard)
    Mousetrap.unbind('space')
    AssetPreviewService.closePreview()
  })

  $scope.getTextForSearchHeader = function () {
    if ($scope.breadcrumb && $scope.breadcrumb.current && $scope.breadcrumb.current.title) {
      if ($scope.search.state.term) {
        return $translate.instant('resultsForTerm', {
          term: $scope.search.state.term,
          collection: $scope.breadcrumb.current.title
        })
      } else {
        return $translate.instant('showingResultsToFilters')
      }
    }
  }

  $scope.clearSearch = function (skipRequest) {
    $scope.search = {
      formatId: null,
      category: null,
      templates: [],
      collections: [],
      count: 0,
      pagination: {
        top: 10,
        skip: 0
      },
      state: {
        term: '',
        searching: false,
        loading: false
      }
    }

    $scope.sidebar.items.forEach(item => {
      item.selected = null
    })

    $location.search({ ...$state.params, search: null })

    if (skipRequest) {
      return
    }

    api._getCollectionTemplates($scope.breadcrumb.current, null, null, 0, true, null, null)
    api._getSubCollections($scope.breadcrumb.current, 0, true)
  }

  $scope.showMoreCollections = function () {
    $scope.collectionData.templateIndex++
    api._getCollectionTemplates($scope.breadcrumb.current, $scope.search.formatId, $scope.search.category, $scope.collectionData.templateIndex, null, null, null)
  }

  $scope.doGlobalSearch = function (term) {
    $state.go('arts.templates', {
      search: term
    })
  }

  $scope.changeCollectionPage = api._changeCollectionPage

  $scope.cleanFilters = function (item) {
    if (item.name === 'formats') {
      $scope.search.formatId = null
    } else if (item.name === 'categories') {
      $scope.search.category = null
    }

    item.selected = null
    api._getCollectionTemplates($scope.breadcrumb.current, $scope.search.formatId, $scope.search.category, 0, true, null, null)
    api._getSubCollections($scope.breadcrumb.current, 0, true)
  }

  $scope.createBlankArt = function () {
    $scope.openFormatDialog()
  }

  $scope.addCollectionClick = function () {
    api.getCreateCampaignDialogController().then(({ CreateCampaignDialogController }) => {
      ModalService.showModal({
        templateId: 'createCampaign.html',
        templateUrl: '/admin/dialogs/create-campaign/create-campaign-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        allowMultiple: true,
        controller: CreateCampaignDialogController,
        data: {
          artCollectionId: $scope.breadcrumb.current.id,
          showHightlightOption: false
        }
      }).then(changed => {
        if (changed) {
          api._getCollectionById($stateParams.id, true)
        }
      })
    })
  }

  $scope.openCollection = function (collection) {
    $scope.clearSearch()
    $rootScope.$emit('arts.clear-arts-filters')
    $state.go('arts.collection', {
      id: collection.id,
      from: $scope.breadcrumb.current.id,
      pageHistory: $scope.breadcrumb.history
    })
  }

  $scope.navigateToCollectionClick = function (collection) {
    let index = $scope.breadcrumb.history.findIndex(item => item.id === collection.id)

    if (index !== -1) {
      $scope.breadcrumb.history.splice(++index)
    }

    $scope.breadcrumb.current = $scope.breadcrumb.history[$scope.breadcrumb.history.length - 1]

    $scope.clearSearch()
    api._changeSearchPlaceholder($scope.breadcrumb.current)

    $rootScope.$emit('arts.clear-arts-filters')

    $state.go('arts.collection', {
      id: $scope.breadcrumb.history[$scope.breadcrumb.history.length - 1] ? $scope.breadcrumb.history[$scope.breadcrumb.history.length - 1].id : null,
      from: $scope.breadcrumb.history[$scope.breadcrumb.history.length - 2] ? $scope.breadcrumb.history[$scope.breadcrumb.history.length - 2].id : null,
      pageHistory: $scope.breadcrumb.history
    })
  }

  function _changeToEditMode (value) {
    $scope.editMode = value

    if ($scope.editMode) {
      $location.search({ edit: true })
      api._getMaterialsSortAndOrderConfigurations()
        .then(() => {
          if ($scope.materialsSort === 'manual') {
            api._activateTemplatesSortable()
            api._activateCollectionsSortable()
          }
        })
      SegmentService.track('arts-collectionedit-view')
    } else {
      $location.search({})
      api._disableSortable()
    }

    api._setHeaderNavigation($scope.editMode)
  }

  function _onSearch (term) {
    api._cleanAllSelections()
    $scope.search.term = term
    $scope.search.count = null
    $scope.setFilters($scope.filters)
  }

  $scope.closeArtFilters = function () {
    $scope.flags.showFilter = false
  }

  $scope.onLastitemLoad = function () {
    $timeout(() => {
      api._addInfiniteScroll()
    }, 2000, false)
  }

  $scope.openImportModal = function () {
    api.getImportSvgDialogController().then(({ ImportSvg }) => {
      const addCompanyDialog = UdsModalService.createModal({
        controller: ImportSvg,
        modalName: 'importDialog',
        data: {
          artCollectionId: $scope.breadcrumb.current.id
        }
      })

      addCompanyDialog.open()
    })
  }

  $scope.openImportTemplate = () => {
    getAttachInsideTheModuleModalController().then(({ AttachInsideTheModuleModalController }) => {
      const attachInsideTheModuleModal = UdsModalService.createModal({
        controller: AttachInsideTheModuleModalController,
        modalName: 'attachInsideTheModuleModal',
        data: {
          selectedTab: 'recents',
          location: 'materials',
          avoidSuccessOnConfirm: true
        },
        onClose: (assetsToAttach) => {
          if (!assetsToAttach?.length) {
            return
          }

          api._openTemplatePropertiesDialog(assetsToAttach)
        }
      })

      attachInsideTheModuleModal.open()
    })
  }

  $scope.openFormatDialog = () => {
    api.getArtSizeDialogController().then(({ ArtSizeDialogController }) => {
      const artSizeDialog = UdsModalService.createModal({
        controller: ArtSizeDialogController,
        modalName: 'artSizeDialog',
        data: {
          artCollectionId: $stateParams.id
        }
      })

      artSizeDialog.open()
    })
  }

  $scope.getMainContent = () => {
    return $('.collection-list-content')[0]
  }

  $scope.handleDropMaterials = (files, collectionId) => {
    collectionId = parseInt(collectionId)
    MaterialUploadService.uploadMaterials(files, collectionId, api._openTemplatePropertiesDialog)
  }

  function _changeCollectionPage (token, stateParams, fromParams) {
    $(document).scrollTop(0)

    let pageToken = Number(token)

    if (!fromParams || !pageToken) {
      pageToken = isNaN(pageToken) ? 1 : pageToken + 1
    }

    if (pageToken < 1) {
      pageToken = 1
    }

    $scope.currentPage = pageToken
    $scope.indexToken = pageToken - 1

    $scope.search.pagination.skip = (pageToken - 1) * $scope.search.pagination.top

    if (stateParams && stateParams.search) {
      api._onCollectionSearch(stateParams.search, { ...stateParams }, pageToken, true)
    } else {
      api._onCollectionSearch($scope.search.state.term, $scope.filters, pageToken, false)
    }
  }

  function _onCollectionSearch (term, filters, pageToken, isFirstToLoad) {
    if (filters && !Array.isArray(filters.artTagIds)) {
      filters.artTagIds = filters.artTagIds ? [filters.artTagIds] : []
    }

    const collection = $scope.breadcrumb.current || $stateParams
    const search = $scope.search
    const state = search.state
    const pagination = search.pagination

    const searchTerm = term || null
    const page = pageToken && pageToken !== 1 ? pageToken : null

    $location.search({ ...$stateParams, ...filters, search: searchTerm, id: null, from: null, pageHistory: null, page })

    const hasFilters = filters && Object.keys(filters).some((key) => {
      return api._checkEmptyValues(key, filters[key])
    })

    if (!term && !hasFilters) {
      if (state.searching) {
        $scope.clearSearch()
      }
      return
    }

    state.term = term
    state.searching = true
    state.loading = true

    let filtersParams = {}

    if (filters) {
      filtersParams = {
        formatId: filters.formatId,
        customizationLevel: filters.customizationLevel,
        needApproval: filters.needApproval,
        groupId: filters.groupId,
        createdAt: filters.createdAt,
        templateExpiration: filters.templateExpiration,
        isArchived: filters.isArchived,
        artTagIds: filters.artTagIds
      }
    }
    pagination.collections.skip = 0
    pagination.templates.skip = 0

    const collectionParams = {
      top: pagination.collections.top,
      skip: pagination.collections.skip,
      search: term,
      ...filtersParams
    }

    const templateParams = {
      top: pagination.templates.top,
      skip: pagination.templates.skip,
      search: term,
      ...filtersParams
    }

    const shouldSkipCollections =
      filters.customizationLevel ||
      filters.formatId ||
      filters.needApproval !== null ||
      filters.artTagIds.length > 0

    const templatePromise = ArtCollectionsService.getTemplatesById(collection.id, templateParams)
    const collectionPromise = shouldSkipCollections
      ? Promise.resolve({ rows: [], count: 0 })
      : ArtCollectionsService.getCollectionsById(collection.id, collectionParams)

    $q.all([templatePromise, collectionPromise]).then(([templates, collections]) => {
      const safeTemplates = templates || { rows: [], count: 0 }
      const safeCollections = collections || { rows: [], count: 0 }

      search.templates = safeTemplates.rows
      search.templateCount = safeTemplates.count
      search.collections = safeCollections.rows
      search.collectionCount = safeCollections.count
      search.count = Number(safeTemplates.count) + Number(safeCollections.count)

      state.loading = false
    })
  }

  $scope.loadMoreCollectionsOnSearch = function () {
    api._loadMoreCollectionsOnSearch()
  }

  $scope.loadMoreTemplatesOnSearch = function () {
    api._loadMoreTemplatesOnSearch()
  }

  function _loadMoreCollectionsOnSearch () {
    const collection = $scope.breadcrumb.current || $stateParams
    const filters = $scope.filters
    const state = $scope.search.state
    const term = state.term
    const pagination = $scope.search.pagination.collections

    state.loadingCollections = true
    pagination.skip += 8

    const params = {
      top: pagination.top,
      skip: pagination.skip,
      search: term,
      ...filters
    }
    ArtCollectionsService.getCollectionsById(collection.id, params).catch((err) => {
      ToastService.defaultErrorToast()
      console.error(err)
    }).then(collections => {
      $scope.search.collections.push(...collections.rows)
    }).finally(() => {
      state.loadingCollections = false
    })
  }

  function _loadMoreTemplatesOnSearch () {
    const collection = $scope.breadcrumb.current || $stateParams
    const filters = $scope.filters
    const state = $scope.search.state
    const term = state.term
    const pagination = $scope.search.pagination.templates

    state.loadingTemplates = true
    pagination.skip += 8

    const params = {
      top: pagination.top,
      skip: pagination.skip,
      search: term,
      ...filters
    }

    ArtCollectionsService.getTemplatesById(collection.id, params).catch((err) => {
      ToastService.defaultErrorToast()
      console.error(err)
    }).then(templates => {
      $scope.search.templates.push(...templates.rows)
    }).finally(() => {
      state.loadingTemplates = false
    })
  }

  function _searchTemplatesByProduct (product) {
    $(document).scrollTop(0)
    const oldSelectedFormatId = $scope.search.formatId
    const index = $scope.sidebar.items.findIndex(item => item.name === 'formats')

    $scope.collectionData = {
      templates: [],
      collections: [],
      top: 10,
      templateCount: 0,
      collectionCount: 0,
      templateIndex: 0
    }

    if (oldSelectedFormatId !== product.id) {
      $scope.search.formatId = product.id
      api._getCollectionTemplates($scope.breadcrumb.current, $scope.search.formatId, $scope.search.category, 0, true, true, TEMPLATES_SEARCH_CURRENT)
      $timeout(() => {
        $scope.sidebar.items[index].selected = product.id
      })
    } else {
      $timeout(() => {
        $scope.cleanFilters($scope.sidebar.items[index])
      })
    }
  }

  function _changeSearchPlaceholder (collection) {
    if (collection) {
      $scope.$emit('headerSearch.placeholder', $translate.instant('searchIn') + ' ' + collection.title)
    } else {
      $scope.$emit('headerSearch.placeholder', null)
    }
  }

  function _getCollectionTemplates (collection, product, category, index, reset, forceUpdate, templateSearchMode) {
    $scope.loadingMoreItems = true
    $scope.breadcrumb.loading = true
    const skip = $scope.collectionData.top * index

    const getCacheId = () => {
      let cacheId = ''

      if (product) {
        cacheId = `product-${skip}-${product}`
      } else if (category) {
        cacheId = `category-${skip}-${category}`
      }

      if (cacheId && templateSearchMode) {
        return `${cacheId}-${templateSearchMode}`
      }

      if (cacheId && !templateSearchMode) {
        return cacheId
      }

      return `pagination-${skip}`
    }

    const cacheId = getCacheId()

    const params = {
      top: $scope.collectionData.top,
      skip,
      formatId: product,
      isArchived: $stateParams.isArchived === 'true'
    }

    if (templateSearchMode) {
      params.searchMode = templateSearchMode
    }

    if (category) {
      params.artTagIds = [category]
    }

    if (!collection) {
      return
    }

    if (reset || !$scope.collectionData.templates) {
      $scope.collectionData.templates = []
    }

    if (forceUpdate) {
      api._callGetTemplates(collection, params)
      return
    }

    handleTemplatePagination(cacheId, {
      requestCallback: (cache) => {
        ArtCollectionsService.getTemplatesById(collection.id, params)
          .catch(ToastService.defaultErrorToast)
          .then(response => {
            $scope.collectionData.templateCount = response.count
            $scope.collectionData.templates.push(...response.rows)
            $scope.collectionData.templates.sort((a, b) => {
              if (a.order === undefined) return 1
              if (b.order === undefined) return -1
              return a.order - b.order
            })

            cache[cacheId] = { templates: $scope.collectionData.templates, templatesCount: response.count }
          })
          .finally(() => {
            $scope.breadcrumb.loading = false
            $scope.loadingMoreItems = false
          })
      },
      cacheCallback: (cache, updateTemplate, removeTemplates) => {
        const updatedTemplates = updateTemplate($scope.templateParam.id, cache[cacheId].templates)
        const updateCacheTemplates = removeTemplates(updatedTemplates, 'archived-template', 'id')

        const newTemplatesCount = cache[cacheId].templatesCount - (updatedTemplates.length - updateCacheTemplates.length)

        $timeout(() => {
          $scope.collectionData.templates = updateCacheTemplates
          $scope.collectionData.templateCount = newTemplatesCount
        }, 0, true)

        cache[cacheId] = { templates: updateCacheTemplates, templatesCount: newTemplatesCount }
        $scope.breadcrumb.loading = false
        $scope.loadingMoreItems = false

        $timeout(() => {
          restoreScroll()
          restartRecording()
        }, 100, false)
      }
    })
    $scope.loadingMoreItems = false
  }

  function _callGetTemplates (collection, params) {
    ArtCollectionsService.getTemplatesById(collection.id, params)
      .catch(ToastService.defaultErrorToast)
      .then(response => {
        $scope.collectionData.templateCount = response.count
        $scope.collectionData.templates = response.rows
      })
      .finally(() => {
        $scope.breadcrumb.loading = false
        $scope.loadingMoreItems = false
      })
  }

  function _getCollectionById (id, forceUpdate) {
    $scope.breadcrumb.loading = true

    ArtCollectionsService.find(id, {
      skipArchived: true
    })
      .catch(ToastService.defaultErrorToast)
      .then(collection => {
        if (!collection) {
          $state.go('arts.templates')

          return
        }

        if (collection.isArchived === true) {
          $scope.headerNavigation.tag = {
            label: $translate.instant('archived'),
            type: 'brand'
          }

          const unarchiveButton = $rootScope.isUserSysAdminAdminDesigner() ? {
            type: 'button',
            btnType: 'primary',
            label: $translate.instant('unarchiveFolder'),
            icon: 'dam',
            onClick: () => {
              api._unarchiveCollection(collection)
            }
          } : null

          $scope.headerToolbar.rightButtons = [
            unarchiveButton
          ]

          $scope.headerNavigation.buttons = []
        }

        if (!$scope.breadcrumb.current) {
          $scope.breadcrumb.current = collection
        }

        let object = null

        if ($scope.breadcrumb && $scope.breadcrumb.history) {
          object = $scope.breadcrumb.history.find(item => item.id === collection.id)
        }

        if (!object && $scope.breadcrumb && $scope.breadcrumb.history) {
          $scope.breadcrumb.history.push(collection)
        }

        $scope.sidebar = {
          items: [],
          selected: {}
        }

        SegmentService.track('arts-colecao-pageview', {
          is_highlight: collection.highlighted,
          is_subcollection: !!($scope.breadcrumb.history && $scope.breadcrumb.history.length >= 2)
        })

        $scope.pageTitle = $scope.breadcrumb.history.length ? $scope.breadcrumb.history[$scope.breadcrumb.history.length - 1].title : ''
        api._formatBreadcrumb()
        api._changeSearchPlaceholder($scope.breadcrumb.current)
        api._getCollectionTemplates(collection, null, null, 0, true, forceUpdate, null)
        api._getSubCollections(collection, 0, true, forceUpdate)
      }).then(() => {
        if (!forceUpdate) {
          if ($scope.materialsSort === 'manual') {
            api._initializeDraggable()
          }
          api._initializeHoverLogger()
        }
      })
  }

  function _unarchiveCollection (collection) {
    const modalConfig = {
      title: $translate.instant('archiveUnarchiveCollectionDialog.title'),
      buttonCancelText: $translate.instant('cancel'),
      buttonConfirmText: $translate.instant('archiveUnarchiveCollectionDialog.buttonUnarchive'),
      description: $translate.instant('archiveUnarchiveCollectionDialog.descriptionUnarchive'),
      onConfirm: () => {
        api._moveCollection(collection)
      }
    }

    ConfirmationModalService.createModal(modalConfig)
  }

  function _moveCollection (collection) {
    ArtCollectionsService.unarchiveArtCollection(collection.id).then(() => {
      api.getMoveTemplateCollectionController().then(({ MoveTemplateCollectionController }) => {
        ModalService.showModal({
          templateId: 'moveTemplateCollection.html',
          templateUrl: '/arts/dialogs/move-template-collection/move-template-collection-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          allowMultiple: true,
          controller: MoveTemplateCollectionController,
          data: {
            data: collection,
            type: 'collection'
          }
        }).then(info => {
          if (info && info.changed) {
            let root = null
            if (collection.parentId && !collection.highlighted) {
              root = collection.parentId
            }
            $rootScope.$emit('arts.clear-arts-filters')
            $state.go('arts.collection', {
              id: collection.id,
              pageHistory: [],
              root,
              isArchived: false
            })
            $scope.filters.isArchived = false
            api._onFilter($scope.filters)
            api._onSearch($scope.search.state.term)
            activate()
          }
        })
      })
    }).catch(() => {
      ToastService.defaultErrorToast()
    })
  }

  function _openTemplatePropertiesDialog (assetsToAttach) {
    const assetsDetailsPromises = assetsToAttach.map((asset) => NewAssetService.getAssetDetails(asset.id, { formatData: 'raw' }))

    Promise.all(assetsDetailsPromises).then((assetsDetails) => {
      const bulkTemplates = assetsToAttach.length > 1
      api.getTemplatePropertiesDialogController().then(({ TemplatePropertiesDialogController }) => {
        const templatePropertiesDialog = UdsModalService.createModal({
          controller: TemplatePropertiesDialogController,
          modalName: 'templatePropertiesDialog',
          data: {
            bulkTemplates,
            assets: assetsDetails,
            isCustomizable: false,
            artCollectionId: $stateParams.id
          }
        })

        templatePropertiesDialog.open()
      })
    })
  }

  function _searchTemplatesByCategory (category) {
    $(document).scrollTop(0)
    const oldSelectedCategoryId = $scope.search.category
    const index = $scope.sidebar.items.findIndex(item => item.name === 'categories')

    $scope.collectionData = {
      templates: [],
      collections: [],
      top: 10,
      templateCount: 0,
      collectionCount: 0,
      templateIndex: 0
    }

    if (oldSelectedCategoryId !== category.id) {
      $scope.search.category = category.id
      api._getCollectionTemplates($scope.breadcrumb.current, $scope.search.formatId, $scope.search.category, 0, true, true, TEMPLATES_SEARCH_CURRENT)
      $timeout(() => {
        $scope.sidebar.items[index].selected = category.id
      })
    } else {
      $timeout(() => {
        $scope.cleanFilters($scope.sidebar.items[index])
      })
    }
  }

  function _getSubCollections (collection, index, clear, forceUpdate) {
    if (!collection) {
      return
    }

    if (clear) {
      $scope.collectionData.collectionCount = 0
      $scope.collectionData.collections = []
    }

    const params = {
      top: 2,
      skip: 2 * index,
      isArchived: $stateParams.isArchived === 'true'
    }

    const cacheId = params.skip

    handleTemplatePagination(cacheId, {
      requestCallback: (cache) => {
        ArtCollectionsService.getCollectionsById(collection.id, params).then(collections => {
          $scope.collectionData.collections.push(...collections.rows)
          $scope.collectionData.collectionCount = collections.count

          if ($scope.collectionData.collections.length < $scope.collectionData.collectionCount) {
            api._getSubCollections(collection, ++index)
          }

          cache[cacheId] = { collections: $scope.collectionData.collections, collectionsCount: $scope.collectionData.collectionCount }
        })
      },
      cacheCallback: (cache, updateCollection, removeCollection) => {
        const updatedCollections = updateCollection($scope.collectionParam.id, cache[cacheId].collections, 'collection', 'title')
        const updateCacheCollections = removeCollection(updatedCollections, 'archived-collection', 'id')

        const newCollectionsCount = cache[cacheId].collectionsCount - (updatedCollections.length - updateCacheCollections.length)

        $timeout(() => {
          $scope.collectionData.collections = updateCacheCollections
          $scope.collectionData.collectionCount = newCollectionsCount
        }, 0, true)

        $timeout(() => {
          restoreScroll()
          restartRecording()
        }, 100, false)
      }
    }, forceUpdate)
  }

  function _activateCollectionsSortable () {
    if (!$rootScope.isUserSysAdminAdminDesigner()) {
      return
    }

    let sectionElement = document.getElementsByClassName('sortable-collections')

    if (sectionElement) {
      sectionElement = Array.from(sectionElement)
      sectionElement = sectionElement[0]
    }

    if (sectionElement) {
      getSortable().then(({ Sortable }) => {
        $timeout(() => {
          sortableCollections = Sortable.create(sectionElement, {
            group: 'collections',
            sort: true,
            animation: 150, // time of animation
            ghostClass: 'collection-ghost', // class name for the drop placeholder
            onUpdate: api._onUpdate
          })
        }, 1000, false)
      })
    }
  }

  function _activateTemplatesSortable () {
    if (!$rootScope.isUserSysAdminAdminDesigner()) {
      return
    }

    let sectionElement = document.getElementsByClassName('sortable-templates')

    if (sectionElement) {
      sectionElement = Array.from(sectionElement)
      sectionElement = sectionElement[0]
    }

    if (sectionElement) {
      getSortable().then(({ Sortable }) => {
        $timeout(() => {
          sortableTemplates = Sortable.create(sectionElement, {
            group: 'templates',
            sort: true,
            animation: 150, // time of animation
            ghostClass: 'templates-ghost', // class name for the drop placeholder
            onUpdate: api._onUpdate
          })
        }, 1000, false)
      })
    }
  }

  function _onUpdate (e) {
    const oldIndex = e.oldIndex
    const newIndex = e.newIndex

    const itemElement = e.item
    let item = null

    if (itemElement.id) {
      item = itemElement.id
    } else if (itemElement.getAttribute('data-id')) {
      item = 'collection-item-' + itemElement.getAttribute('data-id')
    } else if (itemElement.querySelector('[data-id]')) {
      const childId = itemElement.querySelector('[data-id]').getAttribute('data-id')
      item = 'collection-item-' + childId
    }

    if (!item) {
      ToastService.showErrorToast($translate.instant('generalToastErrors.couldNotFindItemIdForDragAndDropOperation'))
      return
    }

    const isTemplate = item.includes('template-item')
    const itemId = item.replace(/\D/g, '')

    $scope.loadingOrder = true

    api._changeItemsOrder(isTemplate, itemId, newIndex, oldIndex)

    if (isTemplate) {
      SegmentService.track('arts-template-order', { place: 'Collection' })
      TemplateService.changeTemplateOrder(itemId, newIndex).then(api._successUpdateOrder) // change order on backend
    } else {
      SegmentService.track('arts-collection-order', { place: 'Collection' })
      ArtCollectionsService.updateItemOrder(itemId, newIndex).then(api._successUpdateOrder) // change order on backend
    }
  }

  function _changeItemsOrder (isTemplate, itemId, newIndex, oldIndex) {
    if (isTemplate) {
      const template = $scope.collectionData.templates.find(item => item.id === parseInt(itemId))

      if (template) {
        template.order = newIndex
      }

      if (newIndex > oldIndex) {
        for (let i = 0; i < $scope.collectionData.templates.length; i++) {
          if ($scope.collectionData.templates[i].id !== parseInt(itemId)) {
            if ($scope.collectionData.templates[i].order <= newIndex && $scope.collectionData.templates[i].order >= oldIndex) {
              $scope.collectionData.templates[i].order--
            }
          }
        }
      } else {
        for (let i = 0; i < $scope.collectionData.templates.length; i++) {
          if ($scope.collectionData.templates[i].id !== parseInt(itemId)) {
            if ($scope.collectionData.templates[i].order >= newIndex && $scope.collectionData.templates[i].order <= oldIndex) {
              $scope.collectionData.templates[i].order++
            }
          }
        }
      }
    } else {
      let collection = null
      collection = $scope.collectionData.collections.find(item => item.id === parseInt(itemId))

      if (collection) {
        collection.order = newIndex
      }

      if (newIndex > oldIndex) {
        for (let i = 0; i < $scope.collectionData.collections.length; i++) {
          if ($scope.collectionData.collections[i].id !== parseInt(itemId)) {
            if ($scope.collectionData.collections[i].order <= newIndex && $scope.collectionData.collections[i].order >= oldIndex) {
              $scope.collectionData.collections[i].order--
            }
          }
        }
      } else {
        for (let i = 0; i < $scope.collectionData.collections.length; i++) {
          if ($scope.collectionData.collections[i].id !== parseInt(itemId)) {
            if ($scope.collectionData.collections[i].order >= newIndex && $scope.collectionData.collections[i].order <= oldIndex) {
              $scope.collectionData.collections[i].order++
            }
          }
        }
      }
    }
  }

  function _disableSortable () {
    $timeout(() => {
      sortableTemplates.option('disabled', true)
      sortableCollections.option('disabled', true)
    }, 500, false)
  }

  function _successUpdateOrder () {
    $timeout(() => {
      $scope.$apply(() => {
        $scope.loadingOrder = false
      })
    }, 500, false)
  }

  function _openTemplateSettings (templateId) {
    api.getUploadTemplateDialogController().then(({ UploadTemplateDialogController }) => {
      ModalService.showModal({
        templateId: 'uploadTemplate.html',
        templateUrl: '/arts/dialogs/upload-template/upload-template-dialog.html?$$REVISION$$',
        destroyable: true,
        observeChanges: true,
        controller: UploadTemplateDialogController,
        data: {
          isUploadingTemplate: false,
          id: templateId
        }
      }).then(info => {
        $location.search({ ...$stateParams, id: null, template: null })
        if (info && info.wasUpdated) {
          $scope.$emit('reload-arts-page')
        }
      })
    })
  }

  function _checkEmptyValues (filter, value) {
    if (Array.isArray(value) && value.length) {
      return true
    } else if (!Array.isArray(value) && value !== undefined && value !== null && value !== '') {
      return true
    }

    return false
  }

  function _checkIfPageExists (count, top) {
    if (!count) {
      return
    }

    const paginationSize = Math.ceil(count / top)

    if ($scope.currentPage > paginationSize) {
      $scope.search.count = null
      api._changeCollectionPage(1, $stateParams, true)
      ToastService.showErrorToast($translate.instant('thisPageDoesNotExist'))
    }
  }

  function _addInfiniteScroll () {
    const container = $('.content-container-two-menu.dashboard')
    if (container.length) {
      container.scroll(() => {
        const loading = $scope.breadcrumb.loading || $scope.search.state.loading || $scope.search.state.searching

        if (!loading && $scope.collectionData.templateCount > $scope.collectionData.templates.length && container.scrollTop() + container.innerHeight() >= container[0].scrollHeight - 1) {
          $scope.showMoreCollections()
        }
      })
    }
  }

  $scope.getPreviewAssets = (section, top, skip, startFromId, previewSort) => {
    const deferred = $q.defer()
    ArtCollectionsService.getTemplatesById(section, { top, skip, startFromId, previewSort }).then((res) => {
      deferred.resolve({
        assets: res.rows,
        count: res.count
      })
    })

    return deferred.promise
  }

  function _handleKeyboardNavigation () {
    document.addEventListener('keydown', api._handleNavigateThroughKeyboard)
  }

  function _handleQuickPreview () {
    Mousetrap.bind('space', api._handleOpenQuickPreview)
  }

  function _handleOpenQuickPreview (ev) {
    if ((ev.code !== 'Space' && ev.keyCode !== 32) || !$scope.selectedTemplates.length) {
      return
    }
    ev.preventDefault()

    if (ev.repeat) {
      return
    }

    if (!AssetPreviewService.assetPreviewIsOpen() && !AssetPreviewService.assetQuickPreviewIsOpen()) {
      AssetPreviewService.openAssetQuickPreview({
        currentAsset: $scope.selectedTemplates[$scope.selectedTemplates.length - 1],
        assets: $scope.search.templates?.length ? $scope.search.templates : $scope.collectionData.templates
      })
    } else if (!AssetPreviewService.assetPreviewIsOpen() && AssetPreviewService.assetQuickPreviewIsOpen()) {
      AssetPreviewService.closePreview()
    }
  }

  function _handleNavigateThroughKeyboard (ev) {
    const isArrowLeft = ev.code === 'ArrowLeft'
    const isArrowRight = ev.code === 'ArrowRight'
    const isShiftPressed = ev.shiftKey === true
    const isModalOpen = ModalService.getCurrentModal()
    const isAssetPreviewOpen = AssetPreviewService.assetPreviewIsOpen()

    if ((!$scope.selectedTemplates.length && !$scope.selectedCollections.length) || isModalOpen || isAssetPreviewOpen) {
      return
    }

    const hasSelectedTemplate = $scope.selectedTemplates.length > 0
    const hasSelectedCollection = $scope.selectedCollections.length > 0

    let sectionTemplates = []
    let sectionCollections = []

    if ($scope.search.state.searching) {
      sectionTemplates = $scope.search.templates || []
      sectionCollections = $scope.search.collections || []
    } else {
      sectionTemplates = $scope.collectionData.templates || []
      sectionCollections = $scope.collectionData.collections || []
    }

    const templatesCount = sectionTemplates.length
    const collectionsCount = sectionCollections.length
    const currentSelectedTemplateIndex = hasSelectedTemplate ? sectionTemplates.findIndex((template) => template.id === $scope.selectedTemplates[$scope.selectedTemplates.length - 1].id) : -1
    const currentSelectedCollectionIndex = hasSelectedCollection ? sectionCollections.findIndex((collection) => collection.id === $scope.selectedCollections[$scope.selectedCollections.length - 1].id) : -1

    if (isShiftPressed) {
      let lastSelectionDirection = ''

      if ($scope.selectedTemplates.length > 1) {
        const lastIndex = sectionTemplates.findIndex(template => template.id === $scope.selectedTemplates[$scope.selectedTemplates.length - 1].id)
        const secondLastIndex = sectionTemplates.findIndex(template => template.id === $scope.selectedTemplates[$scope.selectedTemplates.length - 2].id)

        if (lastIndex > secondLastIndex) {
          lastSelectionDirection = 'right'
        } else if (lastIndex < secondLastIndex) {
          lastSelectionDirection = 'left'
        }
      } else if ($scope.selectedCollections.length > 1) {
        const lastIndex = sectionCollections.findIndex(collection => collection.id === $scope.selectedCollections[$scope.selectedCollections.length - 1].id)
        const secondLastIndex = sectionCollections.findIndex(collection => collection.id === $scope.selectedCollections[$scope.selectedCollections.length - 2].id)

        if (lastIndex > secondLastIndex) {
          lastSelectionDirection = 'right'
        } else if (lastIndex < secondLastIndex) {
          lastSelectionDirection = 'left'
        }
      }

      if (lastSelectionDirection === 'left' && isArrowRight) {
        if (hasSelectedCollection && $scope.selectedCollections.length > 0) {
          api._unselectLastItemFromSelectedItems('collection')
          return
        } else if (hasSelectedTemplate && $scope.selectedTemplates.length > 0) {
          api._unselectLastItemFromSelectedItems('template')
          return
        }
      } else if (lastSelectionDirection === 'right' && isArrowLeft) {
        if (hasSelectedTemplate && $scope.selectedTemplates.length > 0) {
          api._unselectLastItemFromSelectedItems('template')
          return
        } else if (hasSelectedCollection && $scope.selectedCollections.length > 0) {
          api._unselectLastItemFromSelectedItems('collection')
          return
        }
      }

      // Specific case for when there is only one template selected and multiple collections selected
      // The opposite case also occurs, which is why this specific validation is needed

      if ($scope.selectedTemplates.length === 1 &&
          $scope.selectedCollections.length > 0 &&
          (lastSelectionDirection === '' || lastSelectionDirection === null) &&
          isArrowLeft &&
          !$scope.selectedTemplates[0].firstSelection
      ) {
        api._unselectLastItemFromSelectedItems('template')
      }

      if ($scope.selectedCollections.length === 1 &&
          $scope.selectedTemplates.length > 0 &&
          (lastSelectionDirection === '' || lastSelectionDirection === null) &&
          isArrowRight &&
          !$scope.selectedCollections[0].firstSelection
      ) {
        api._unselectLastItemFromSelectedItems('collection')
      }

      if (isArrowLeft) {
        if (hasSelectedTemplate && currentSelectedTemplateIndex > 0) {
          const previousTemplate = sectionTemplates[currentSelectedTemplateIndex - 1]
          api._addNewItemToSelectedItems(previousTemplate, 'template')
        } else if (hasSelectedTemplate &&
          currentSelectedTemplateIndex === 0 &&
          collectionsCount > 0 &&
          currentSelectedCollectionIndex === -1) {
          const lastCollection = sectionCollections[collectionsCount - 1]
          api._addNewItemToSelectedItems(lastCollection, 'collection')
        } else if (hasSelectedCollection && currentSelectedCollectionIndex > 0) {
          const previousCollection = sectionCollections[currentSelectedCollectionIndex - 1]
          api._addNewItemToSelectedItems(previousCollection, 'collection')
        }
      } else if (isArrowRight) {
        if (hasSelectedTemplate && currentSelectedTemplateIndex < templatesCount - 1) {
          const nextTemplate = sectionTemplates[currentSelectedTemplateIndex + 1]
          api._addNewItemToSelectedItems(nextTemplate, 'template')
        } else if (hasSelectedCollection && currentSelectedCollectionIndex < collectionsCount - 1) {
          const nextCollection = sectionCollections[currentSelectedCollectionIndex + 1]
          api._addNewItemToSelectedItems(nextCollection, 'collection')
        } else if (hasSelectedCollection &&
          currentSelectedCollectionIndex === collectionsCount - 1 &&
          templatesCount > 0 &&
          currentSelectedTemplateIndex === -1) {
          const firstTemplate = sectionTemplates[0]
          api._addNewItemToSelectedItems(firstTemplate, 'template')
        }
      }
    } else {
      if (isArrowLeft) {
        if (hasSelectedTemplate && currentSelectedTemplateIndex > 0) {
          const previousTemplate = sectionTemplates[currentSelectedTemplateIndex - 1]
          api._unselectAllAndSelectNewItem(previousTemplate, 'template')
        } else if (hasSelectedTemplate && currentSelectedTemplateIndex === 0 && collectionsCount > 0) {
          const lastCollection = sectionCollections[collectionsCount - 1]
          api._unselectAllAndSelectNewItem(lastCollection, 'collection')
        } else if (hasSelectedCollection && currentSelectedCollectionIndex > 0) {
          const previousCollection = sectionCollections[currentSelectedCollectionIndex - 1]
          api._unselectAllAndSelectNewItem(previousCollection, 'collection')
        }
      } else if (isArrowRight) {
        if (hasSelectedTemplate && currentSelectedTemplateIndex < templatesCount - 1) {
          const nextTemplate = sectionTemplates[currentSelectedTemplateIndex + 1]
          api._unselectAllAndSelectNewItem(nextTemplate, 'template')
        } else if (hasSelectedCollection && currentSelectedCollectionIndex < collectionsCount - 1) {
          const nextCollection = sectionCollections[currentSelectedCollectionIndex + 1]
          api._unselectAllAndSelectNewItem(nextCollection, 'collection')
        } else if (hasSelectedCollection && currentSelectedCollectionIndex === collectionsCount - 1 && templatesCount > 0) {
          const firstTemplate = sectionTemplates[0]
          api._unselectAllAndSelectNewItem(firstTemplate, 'template')
        }
      }
    }
  }

  function _unselectAllAndSelectNewItem (newSelectedItem, itemType) {
    api._cleanAllSelections()
    newSelectedItem.selected = true
    if (itemType === 'template') {
      $scope.selectedTemplates.push(newSelectedItem)
    } else if (itemType === 'collection') {
      $scope.selectedCollections.push(newSelectedItem)
    }
    $scope.$apply()
  }

  function _addNewItemToSelectedItems (newSelectedItem, itemType) {
    newSelectedItem.selected = true
    if (itemType === 'template') {
      $scope.selectedTemplates.push(newSelectedItem)
    } else if (itemType === 'collection') {
      $scope.selectedCollections.push(newSelectedItem)
    }
    $scope.$apply()
  }

  function _unselectLastItemFromSelectedItems (itemType) {
    let lastItem = null
    if (itemType === 'template') {
      lastItem = $scope.selectedTemplates.pop()
    } else if (itemType === 'collection') {
      lastItem = $scope.selectedCollections.pop()
    }
    lastItem.selected = false
    $scope.$apply()
  }

  $scope.handleOpenQuickPreview = (event) => api._handleOpenQuickPreview(event)

  $scope.isPreviewEnabled = AssetPreviewService.isPreviewEnabled

  $scope.onSeeAnalyticsResultsByCollection = (event) => {
    const { pricing } = event.detail
    const breadcrumbHistory = $scope.breadcrumb.history

    const lastIndex = breadcrumbHistory.length - 1
    const collection = breadcrumbHistory[lastIndex]

    const analyticsState = 'analytics.dashboard'
    const routeParams = {
      slug: 'arts-overview',
      filterName: 'COLLECTIONS',
      filterValue: collection
    }

    if (pricing) {
      const featureName = $translate.instant('analyticsFilters.advancedFilters.pricing.featureName')
      const featureSlug = ANALYTICS_ADVANCED_FILTERS_KEY

      return api._showUpgradeCompanyPlanDialog(featureName, featureSlug)
    }

    SegmentService.track('arts-collection-analytics-btn')

    if (window.clarity) {
      window.clarity('set', 'arts-collection-analytics-btn', null)
    }

    $state.go(analyticsState, routeParams)
  }

  function _showUpgradeCompanyPlanDialog (featureName = '', featureSlug = '') {
    api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
      const upgradeCompanyPlanDialog = UdsModalService.createModal({
        controller: UpgradeCompanyPlanDialogController,
        modalName: 'upgradeCompanyPlanDialog',
        data: {
          featureName,
          featureSlug
        }
      })

      upgradeCompanyPlanDialog.open()
    })
  }

  function _successGetCompanyFeatures ({ features }) {
    const notHasAnalyticsAdvancedFilters = !features[ANALYTICS_ADVANCED_FILTERS_KEY]

    $scope.analyticsAdvancedFilters = notHasAnalyticsAdvancedFilters
  }

  function _errorGetCompanyFeatures (error) {
    ToastService.defaultErrorToast()
    console.error(error)
  }

  function _formatBreadcrumb () {
    $scope.breadcrumb.history.forEach(item => {
      item.label = item.title
    })

    $scope.headerBreadcrumbs = {
      items: [...$scope.breadcrumb.history],
      onChange: $scope.navigateToCollectionClick
    }
  }

  function _setHeaderNavigation (editMode) {
    const isNotUserRoleAndNotEditMode = $rootScope.isUserSysAdminAdminDesigner() && !editMode
    $scope.headerNavigation = isNotUserRoleAndNotEditMode ? {
      buttons: [{
        type: 'button',
        btnType: 'secondary',
        label: $translate.instant('edit'),
        icon: 'edit',
        onClick: api._changeToEditMode.bind(null, true)
      }]
    } : {}
  }

  function _onFilter (filters, hasPreFilters) {
    if (hasPreFilters) {
      return
    }

    $scope.filters = filters
    $scope.handleSubmitSearch('')
  }

  function _initHeader () {
    const importMaterialDropdownButtons = [{
      icon: 'upload',
      label: $translate.instant('importMaterial'),
      onClick: (evt) => {
        $scope.openImportTemplate(evt)
      }
    }]

    if ($scope.companyFeatures.artsCustomization.access) {
      importMaterialDropdownButtons.push({
        icon: 'upload',
        label: $translate.instant('importSvgTemplate'),
        onClick: (evt) => {
          $scope.openImportModal(evt)
        }
      }, {
        icon: 'file-plus',
        label: $translate.instant('createBlankTemplate'),
        onClick: (evt) => {
          $scope.openFormatDialog(evt)
        }
      })
    }

    const analyticsButton = $rootScope.isUserSysAdminAdmin() ? {
      type: 'icon',
      icon: 'analytics',
      onClick: (evt) => {
        $scope.onSeeAnalyticsResultsByCollection(evt)
      },
      pricing: {
        tooltip: $translate.instant('billingTooltips.haveMoreWithPro'),
        position: 'left',
        prop: $scope.analyticsAdvancedFilters
      }
    } : null

    const createNewButton = $rootScope.isUserSysAdminAdminDesigner() ? {
      type: 'dropdown',
      btnType: 'primary',
      label: $translate.instant('createNew'),
      icon: 'plus',
      options: importMaterialDropdownButtons
    } : null

    const createCollectionButton = $rootScope.isUserSysAdminAdminDesigner() ? {
      type: 'button',
      btnType: 'secondary',
      label: $translate.instant('createCollection'),
      onClick: (evt) => {
        $scope.addCollectionClick(evt)
      }
    } : null

    const rightButtons = [
      analyticsButton,
      createCollectionButton,
      createNewButton
    ].filter(Boolean)

    const exhibitDefaultValue = {
      label: $translate.instant('actives'),
      value: false,
      icon: 'success',
      active: $stateParams.isArchived !== 'true',
      disabled: false
    }

    const exhibitArchivedDefaultValue = {
      label: $translate.instant('archivedPlural'),
      value: true,
      icon: 'archive',
      active: $stateParams.isArchived === 'true',
      disabled: false
    }

    const isArchived = $rootScope.isUserSysAdminAdminDesigner() ? {
      name: 'isArchived',
      type: 'FILTER_BUTTON_SELECT',
      grouped: false,
      defaultValue: exhibitDefaultValue,
      props: {
        label: $translate.instant('exhibit'),
        multiple: false,
        switchMode: true,
        udsDisabled: false,
        options: [
          exhibitDefaultValue,
          exhibitArchivedDefaultValue
        ]
      }
    } : null

    const customizationLevel = $scope.companyFeatures.artsCustomization.access ? {
      name: 'customizationLevel',
      type: 'FILTER_BUTTON_SELECT',
      grouped: false,
      defaultValue: null,
      props: {
        label: $translate.instant('customizationLevel'),
        multiple: false,
        switchMode: false,
        udsDisabled: false,
        options: [
          {
            label: $translate.instant('permissionFree'),
            value: 'FREE_STYLE',
            icon: 'unlock',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('moderate'),
            value: 'ONLY_DOWNLOAD',
            icon: 'lock',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('customizable'),
            value: 'RESTRICTED',
            icon: 'lock-filled',
            active: false,
            disabled: false
          }
        ]
      }
    } : null

    const needApproval = $scope.companyFeatures.artsCustomization.access ? {
      name: 'needApproval',
      type: 'FILTER_BUTTON_SELECT',
      grouped: false,
      defaultValue: null,
      props: {
        label: $translate.instant('templates'),
        multiple: false,
        switchMode: false,
        udsDisabled: false,
        options: [
          {
            label: $translate.instant('withApproval'),
            value: true,
            icon: 'check',
            active: false,
            disabled: false
          },
          {
            label: $translate.instant('withoutApproval'),
            value: false,
            icon: 'close',
            active: false,
            disabled: false
          }
        ]
      }
    } : null

    const groupId = $rootScope.isUserSysAdminAdminDesigner() ? {
      name: 'groupId',
      type: 'INPUT_SELECT',
      grouped: true,
      defaultValue: null,
      props: {
        label: $translate.instant('userGroup'),
        placeholder: $translate.instant('selectPlaceholder'),
        emptyMsg: $translate.instant('noResults'),
        type: 'text',
        hasMoreOptions: false,
        udsDisabled: false,
        pricing: false,
        pricingTooltip: '',
        pricingTooltipPosition: 'top',
        options: []
      },
      loadData: (searchTerm, top, skip) => GroupService.getGroups(top, skip, { searchTerm })
    } : null

    const createdAt = $rootScope.isUserSysAdminAdminDesigner() ? {
      name: 'createdAt',
      type: 'DATE_PICKER',
      grouped: true,
      defaultValue: '',
      props: {
        locale: $rootScope.oUser.locale,
        label: $translate.instant('creationDate'),
        firstDayOfWeek: '1',
        direction: 'right'
      }
    } : null

    const templateExpiration = $rootScope.isUserSysAdminAdminDesigner() ? {
      name: 'templateExpiration',
      type: 'DATE_PICKER',
      grouped: true,
      defaultValue: '',
      props: {
        locale: $rootScope.oUser.locale,
        label: $translate.instant('expiration'),
        firstDayOfWeek: '1',
        direction: 'right'
      }
    } : null

    const filters = [
      isArchived,
      customizationLevel,
      needApproval,
      {
        name: 'artTagIds',
        type: 'INPUT_MULTISELECT',
        grouped: false,
        defaultValue: [],
        props: {
          label: $translate.instant('filterByTags'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          loadButtonLabel: '',
          type: 'tag',
          hasMoreOptions: false,
          udsDisabled: false,
          options: []
        },
        loadData: (name, top, skip) => TagsService.getTags({ name, top, skip })
      },
      {
        name: 'formatId',
        type: 'INPUT_SELECT',
        grouped: $rootScope.isUserSysAdminAdminDesigner(),
        defaultValue: null,
        props: {
          label: $translate.instant('product'),
          placeholder: $translate.instant('selectPlaceholder'),
          emptyMsg: $translate.instant('noResults'),
          type: 'text',
          hasMoreOptions: false,
          udsDisabled: false,
          pricing: false,
          pricingTooltip: '',
          pricingTooltipPosition: 'top',
          options: []
        },
        loadData: (search, top, skip) => FormatsService.getFormats({ search, top, skip })
      },
      groupId,
      createdAt,
      templateExpiration
    ].filter(Boolean)

    $scope.headerToolbar = {
      rightButtons,
      search: {
        filters,
        onFilter: api._onFilter,
        onSearch: api._onSearch
      }
    }
  }

  function _handleCompanyFeatures () {
    return $rootScope.getCompanyFeaturesAndAddons().then(({ features }) => {
      const customizableArtsSlug = String('ARTS.CUSTOMIZABLE_ARTS')
      $scope.companyFeatures.artsCustomization.access = !!features[customizableArtsSlug]
    })
  }

  $scope.onCollectionClick = function (collection, event) {
    const isShiftPressed = event && event.shiftKey
    if (collection.selected) {
      collection.firstSelection = false
      collection.selected = false
      $scope.selectedCollections = $scope.selectedCollections.filter(c => c.id !== collection.id)
    } else {
      if ($scope.selectedCollections.length === 0 && $scope.selectedTemplates.length === 0) {
        collection.firstSelection = true
      }

      if (isShiftPressed) {
        return api._handleShiftClickOnCollection(collection)
      }

      collection.selected = true
      $scope.selectedCollections.push(collection)
    }
  }

  $scope.onTemplateClick = function (template, event) {
    const isShiftPressed = event && event.shiftKey
    if (template.selected) {
      template.firstSelection = false
      template.selected = false
      $scope.selectedTemplates = $scope.selectedTemplates.filter(t => t.id !== template.id)
    } else {
      if ($scope.selectedTemplates.length === 0 && $scope.selectedCollections.length === 0) {
        template.firstSelection = true
      }

      if (isShiftPressed) {
        return api._handleShiftClickOnTemplate(template)
      }

      template.selected = true
      $scope.selectedTemplates.push(template)
    }
  }

  $scope.unselectAllAssets = function () {
    api._cleanAllSelections()
  }

  function _cleanAllSelections () {
    $scope.selectedTemplates.forEach(template => {
      template.firstSelection = false
      template.selected = false
    })

    $scope.selectedCollections.forEach(collection => {
      collection.firstSelection = false
      collection.selected = false
    })

    $scope.selectedTemplates = []
    $scope.selectedCollections = []
  }

  function _unselectAllExceptFirstSelected () {
    const firstSelectedTemplate = $scope.selectedTemplates.find(t => t.firstSelection)
    const firstSelectedCollection = $scope.selectedCollections.find(c => c.firstSelection)

    if (!firstSelectedTemplate && !firstSelectedCollection) {
      return
    }

    $scope.selectedTemplates.concat($scope.selectedCollections).forEach(item => {
      item.selected = false
      item.firstSelection = false
    })

    if (firstSelectedTemplate) {
      firstSelectedTemplate.selected = true
      firstSelectedTemplate.firstSelection = true
      $scope.selectedTemplates = [firstSelectedTemplate]
      $scope.selectedCollections = []
    } else {
      firstSelectedCollection.selected = true
      firstSelectedCollection.firstSelection = true
      $scope.selectedTemplates = []
      $scope.selectedCollections = [firstSelectedCollection]
    }
  }

  function _handleShiftClickOnTemplate (template) {
    document.getSelection().removeAllRanges()
    api._unselectAllExceptFirstSelected()

    const firstSelectedTemplate = $scope.selectedTemplates.find(t => t.firstSelection)
    const firstSelectedCollection = $scope.selectedCollections.find(c => c.firstSelection)
    let sectionTemplates = []
    let sectionCollections = []

    if ($scope.search.state.searching) {
      sectionTemplates = $scope.search.templates || []
      sectionCollections = $scope.search.collections || []
    } else {
      sectionTemplates = $scope.collectionData.templates || []
      sectionCollections = $scope.collectionData.collections || []
    }

    const indexOfClickedTemplate = sectionTemplates.indexOf(template)

    if (firstSelectedTemplate) {
      const indexOfFirstSelectedTemplate = sectionTemplates.indexOf(firstSelectedTemplate)
      const startIndex = Math.min(indexOfFirstSelectedTemplate, indexOfClickedTemplate)
      const endIndex = Math.max(indexOfFirstSelectedTemplate, indexOfClickedTemplate) + 1
      const templatesToSelect = sectionTemplates.slice(startIndex, endIndex)

      templatesToSelect.forEach(t => {
        t.selected = true
      })
      $scope.selectedTemplates = [...templatesToSelect]
    } else if (firstSelectedCollection) {
      const indexOfFirstSelectedCollection = sectionCollections.indexOf(firstSelectedCollection)
      const collectionsToSelect = sectionCollections.slice(indexOfFirstSelectedCollection, (sectionCollections.length))
      const templatesToSelect = sectionTemplates.slice(0, indexOfClickedTemplate + 1)

      collectionsToSelect.forEach(c => {
        c.selected = true
      })
      templatesToSelect.forEach(t => {
        t.selected = true
      })

      $scope.selectedCollections = [...collectionsToSelect]
      $scope.selectedTemplates = [...templatesToSelect]
    }
  }

  function _handleShiftClickOnCollection (collection) {
    document.getSelection().removeAllRanges()
    api._unselectAllExceptFirstSelected()

    const firstSelectedTemplate = $scope.selectedTemplates.find(t => t.firstSelection)
    const firstSelectedCollection = $scope.selectedCollections.find(c => c.firstSelection)
    let sectionTemplates = []
    let sectionCollections = []

    if ($scope.search.state.searching) {
      sectionTemplates = $scope.search.templates || []
      sectionCollections = $scope.search.collections || []
    } else {
      sectionTemplates = $scope.collectionData.templates || []
      sectionCollections = $scope.collectionData.collections || []
    }

    const indexOfClickedCollection = sectionCollections.indexOf(collection)

    if (firstSelectedCollection) {
      const indexOfFirstSelectedCollection = sectionCollections.indexOf(firstSelectedCollection)
      const startIndex = Math.min(indexOfFirstSelectedCollection, indexOfClickedCollection)
      const endIndex = Math.max(indexOfFirstSelectedCollection, indexOfClickedCollection) + 1
      const collectionsToSelect = sectionCollections.slice(startIndex, endIndex)

      collectionsToSelect.forEach(c => {
        c.selected = true
      })
      $scope.selectedCollections = [...collectionsToSelect]
    } else if (firstSelectedTemplate) {
      const indexOfFirstSelectedTemplate = sectionTemplates.indexOf(firstSelectedTemplate)
      const templatesToSelect = sectionTemplates.slice(0, indexOfFirstSelectedTemplate + 1)
      const collectionsToSelect = sectionCollections.slice(indexOfClickedCollection, (sectionCollections.length))

      collectionsToSelect.forEach(c => {
        c.selected = true
      })
      templatesToSelect.forEach(t => {
        t.selected = true
      })

      $scope.selectedCollections = [...collectionsToSelect]
      $scope.selectedTemplates = [...templatesToSelect]
    }
  }

  function _getMaterialsSortAndOrderConfigurations () {
    return CustomerConfigurationsService.getOneConfigurationByType('MATERIALS_COLLECTIONS_SORT', 'STRING')
      .then((sortConfig) => {
        if (sortConfig?.value) {
          $scope.materialsSort = sortConfig.value
        }
      })
  }
}
